import { KyteApp as Kyte} from './KyteApp';
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { withRouter } from "react-router-dom";
import { actionSetListNotification, actionSetChats } from '@/redux/actions';


const mapStateToProps = ({ NotificationReducer, ChatsReducer }) => ({
   $store: {
      NotificationReducer,
      ChatsReducer
   },
});
const mapDispatchToProps = (dispatch) => ({
   $action: bindActionCreators(
      {
         actionSetListNotification: actionSetListNotification,
         actionSetChats: actionSetChats
      },
      dispatch
   ),
});


export const KyteApp: any = compose(
   withRouter,
   connect(mapStateToProps, mapDispatchToProps)
)(Kyte);

